/* eslint-disable no-unused-expressions */
import React from 'react';
import {Checkbox} from '@mui/material';
import './ControlList.scss';
import {connect} from 'react-redux';
import {Prompt} from 'react-router-dom';
import {ControlDto} from '../Dtos/ControlDto';
import {ControlledPartyDto} from '../Dtos/ControlledPartyDto';
import {ControlPlaceDto} from '../Dtos/ControlPlaceDto';
import {OrderDto} from '../Dtos/OrderDto';
import {PaymentClaimDto} from '../Dtos/PaymentClaimDto';
import {PostControlDocumentDto} from '../Dtos/PostControlDocumentDto';
import {PostControlInfoDto} from '../Dtos/PostControlInfoDto';
import {PostControlNoteDto} from '../Dtos/PostControlNoteDto';
import {FindingDto} from '../Dtos/FindingDto';
import {BlockInListDto} from '../Dtos/BlockInListDto';
import * as PropertyBucket from '../../Properties/Properties';
import * as httpService from '../HttpService/HttpService';
import {errorMessageText} from '../HttpService/HttpService';
import {getControllingTeam} from '../ManageControlCommons/ManageControlCommons';
import * as validator from '../Validators/ControlValidator.js';
import {ControlDetailInfo} from '../ControlDetailInfo/ControlDetailInfo';
import 'react-datepicker/dist/react-datepicker.css';
import {AnswerTable} from '../AnswerTable/AnswerTable';
import {Waiter} from '.././WaitingSign/Waiting';
import PopUp from '.././PopUp/PopUp';
import Input from '.././Input/Input';
import DatePickerCustom from '.././DatePickerCustom/DatePickerCustom';
import SelectCustom from '../SelectCustom/SelectCustom';
import {generateControlListDocx} from '.././DocxTemplate/ControlListDocx';
import {customDateConversion} from "../DatePickerCustom/DateHelper";
import {formatSubject} from "../ControlStateHelper";
import {mapNewAnswersToQuestion} from "../documents/helpers";
import {NewPostControlDocumentDto} from "../Dtos/NewPostControlDocumentDto";
import { PublicOrdersProvider } from '../PublicOrders/PublicOrders';
import {AuditDetail} from "../AuditDetail/AuditDetail";
import {draftjsToString} from "../WysiwygEditor/WysiwygHelpers";
import { emptyEditorContentPlainText } from '../../consts/consts';
import {getPaymentClaimsData} from "../../Redux/Actions/PaymentClaims";

class ControlList extends React.Component {
	/* jshint expr: true */
	controlId;
	blocksNotPassed = [];

	constructor(props) {
		super(props);
		this.handleAddParty = this.handleAddParty.bind(this);
		this.handleRemoveParty = this.handleRemoveParty.bind(this);
		this.state = {
			controlId: null,
			isWaiting: true,
			isLocked: true,
			remarksOpened: false,
			questionListData: null,
			showPopup: false,
			showPrepPostContInfo: false,
			showPrepPostContNote: false,
			controlData: null,
			controlResponse: [],
			controlledParties: [],
			controlledPlaces: [],
			controlledOrders: [],
			controlledWops: [],
			otherControlledProjects: [],
			controlledValue: '',
			isSaved: '',
			partyNameClasses: [],
			partyNipClasses: [],
			controllingEntityClasses: ['questionListInputs'],
			placesClasses: ['questionListInputs'],
			orderNumberClasses: [],
			orderNameClasses: [],
			wopsClasses: ['questionListInputs'],
			otherProjectNumberClasses: ['questionListInputs'],
			postContInfoClasses: ['btn save-btn'],
			postContNoteClasses: ['btn save-btn second-btn'],//inactive
			controllingEntity: '',
			tmpControlledPartyName: '',
			tmpControlledPartyIdType: '',
			tmpControlledPartyNip: '',
			tmpControlledPartyPesel: null,
			tmpControlledPartyForeignNumber: '',
			tmpControlledOrderNumber: '',
			tmpControlledOrderName: '',
			tmpControlledOrderContract: '',
			controlledPartiesInputValueLength: 0,
			errorControlledPartyName: '',
			errorControlledPartyIdType: '',
			errorControlledPartiesIdValue: '',
			tmpControlledPlaces: '',
			tmpOrderNumbers: [],
			tmpWopNumbers: '',
			tmpOtherProjectNumber: '',
			disabled: false,
			disabledSave: true,
			controlListApproved: null,
			invalidDates: false,
			activateFormInfo: false,
			isIntroductoryPartEdited: false,
			addedToListInfo: null,
			removedFromListInfo: null,
			publicOrders: [],
			copiedSourceData: {
				controllingEntity: '',
				tmpControlledPartyName: '',
				tmpControlledPartyIdType: '',
				tmpControlledPartyNip: '',
				tmpControlledPartyPesel: null,
				tmpControlledPartyForeignNumber: '',
				tmpControlledPlaces: '',
				tmpOrderNumbers: [],
				tmpWopNumbers: '',
				tmpOtherProjectNumber: '',
				controlledParties: [],
				controlledPlaces: [],
				controlledOrders: [],
				controlledWops: [],
				otherControlledProjects: [],
			},
			isChangeRoutePossible: true,
			isPreventPromptEnabled: true,
			isControlledOrdersModalVisible: false,
			selectedPaymentClaims: {}
		};
		this.handleClosePopUpFunction = this.handleClosePopUpFunction.bind(this);
		this.fromDateRef = React.createRef();
		this.selectTypeRef = React.createRef();
	}

	componentDidMount() {
		this.controlId = this.props.match.params.controlId;
		this.fetchControlData(this.controlId);
	}

	componentDidUpdate(){
		if (!this.state.isLocked){
			const isDataChanged = this.isDataChanged();
			if (isDataChanged && this.state.isChangeRoutePossible){
				this.setState({isChangeRoutePossible: false})
			}
			else if (!isDataChanged && !this.state.isChangeRoutePossible) {
				this.setState({isChangeRoutePossible: true })
			}
		}
	}


	isDataChanged() {
		if (
			this.state.controllingEntity !== this.state.copiedSourceData.controllingEntity ||
			this.state.tmpControlledPartyName !== this.state.copiedSourceData.tmpControlledPartyName ||
			this.state.tmpControlledPartyIdType !== this.state.copiedSourceData.tmpControlledPartyIdType ||
			this.state.tmpControlledPartyNip !== this.state.copiedSourceData.tmpControlledPartyNip ||
			this.state.tmpControlledPartyPesel !== this.state.copiedSourceData.tmpControlledPartyPesel ||
			this.state.tmpControlledPartyForeignNumber !== this.state.copiedSourceData.tmpControlledPartyForeignNumber ||
			this.state.tmpControlledPlaces !== this.state.copiedSourceData.tmpControlledPlaces ||
			this.state.tmpOrderNumbers !== this.state.copiedSourceData.tmpOrderNumbers ||
			this.state.tmpWopNumbers !== this.state.copiedSourceData.tmpWopNumbers ||
			this.state.tmpOtherProjectNumber !== this.state.copiedSourceData.tmpOtherProjectNumber ||
			this.state.dateStart !== this.state.copiedSourceData.dateStart ||
			JSON.stringify(this.state.controlledParties) !== this.state.copiedSourceData.controlledParties ||
			JSON.stringify(this.state.controlledPlaces) !== this.state.copiedSourceData.controlledPlaces ||
			JSON.stringify(this.state.controlledOrders) !== this.state.copiedSourceData.controlledOrders ||
			JSON.stringify(this.state.controlledWops) !== this.state.copiedSourceData.controlledWops ||
			JSON.stringify(this.state.otherControlledProjects) !== this.state.copiedSourceData.otherControlledProjects
		)
		{
			return true;
		}

		return false;
	}

	preventChangeRoute = (newLocation) => {
		this.setState({
			showPopup: true,
			popUp: {
				title: 'Ostrzeżenie',
				notification: PropertyBucket.getCancelMessage(),
				type: 'cancel',
				newLocationLink: newLocation,
				onClickEvent: this.changeRoute,
				closePopUp: this.handleClosePopUpFunction
			},
			isPreventPromptEnabled: false
		});

		return false;
	};

	changeRoute = () => {
		this.setState({
			isPreventPromptEnabled: false
		});

		this.state.popUp.newLocationLink && this.props.history.push(this.state.popUp.newLocationLink)
	};

	checkControlList = () => {

		if (isDisabled(this)) {
			this.showPopup('Błąd', "Proszę zakończyć edycję", 'error')
		} else {
			let validationMessage = '';
			!this.validateControlDates() ? validationMessage += PropertyBucket.getDateStartIsGreaterThanEndMessage() + '\n' : null;
			!this.validateControllingEntity(this.state.controlData) ? validationMessage += PropertyBucket.getFillControllingEntityMessage() + '\n' : null;
			!this.validateControlParties(this.state.controlData) ? validationMessage += PropertyBucket.getFillControlledPartiesMessage() + '\n' : null;
			!this.validateControlPlaces(this.state.controlData) ? validationMessage += PropertyBucket.getFillControlPlacesMessage() + '\n' : null;
			!this.validateList(this.state.questionListData, this) ? validationMessage += this.getNotAllBlockFilledOutWithListErrorMessage() : null;

			if (validationMessage === '') {
				this.setState({
					controlListApproved: true
				});
				this.saveControl(true, false);
				this.showPopup('Komunikat', "Dane poprawne", 'notify')
			} else {
				this.showPopup('Błąd', validationMessage, 'error')
			}
		}
	};

	isWaitingOnOff = (OnOff) => {
		this.setState({
			isWaiting: OnOff
		})
	};

	handleClosePopUpFunction() {
		this.setState({
			showPopup: false,
			isPreventPromptEnabled: true
		});
	}

	handleChangeStartDate = (date) => {
		this.setState({
			dateStart: date == null ? null : new Date(date),
			disabledSave: false,
			controlListApproved: false
		});
	};

	handleChangeControllingEntity = e => {
		this.setState({
			controllingEntity: e.target.value,
			disabledSave: false,
			controlListApproved: false
		});
	};

	handleChangeControlledPartyName = e => {
		this.setState({
			tmpControlledPartyName: e.target.value,
			disabledSave: false,
			controlListApproved: false
		});
	};

	handleChangeControlledPartyIdType = values => {
		this.setState({
			tmpControlledPartyIdType: values[0]?.typeId,
			tmpControlledPartyNip: '',
			tmpControlledPartyPesel: null,
			tmpControlledPartyForeignNumber: '',
			controlledPartiesInputValueLength: 0,
			errorControlledPartiesIdValue: '',
			errorControlledPartyIdType: '',
		});
	};

	handleChangeControlledPartyIdValue = e => {
		this.setState({
			tmpControlledPartyNip: this.state.tmpControlledPartyIdType === 'nip' ? e.target.value : '',
			tmpControlledPartyPesel: this.state.tmpControlledPartyIdType === 'pesel' ? e.target.value : null,
			tmpControlledPartyForeignNumber: this.state.tmpControlledPartyIdType === 'foreignNumber' ? e.target.value : '',
			controlledPartiesInputValueLength: e.target.value.length,
			disabledSave: false,
			controlListApproved: false
		});
	};

	handleChangeControlledPlaces = e => {
		this.setState({
			tmpControlledPlaces: e.target.value,
			disabledSave: false,
			controlListApproved: false
		});
	};

	handleChangeControlledOrderNumber = e => {
		this.setState({
			tmpControlledOrderNumber: e.target.value,
		});
	};

	handleChangeControlledOrderName = e => {
		this.setState({
			tmpControlledOrderName: e.target.value,
		});
	};

	handleChangeControlledOrderContract = e => {
		this.setState({
			tmpControlledOrderContract: e.target.value
		});
	};

	handleChangeWopNumbers = e => {
		this.setState({
			tmpWopNumbers: e.target.value,
			disabledSave: false,
			controlListApproved: false
		});
	};

	handleChangeOtherProjectNumber = e => {
		this.setState({
			tmpOtherProjectNumber: e.target.value,
			disabledSave: false,
			controlListApproved: false
		});
	};

	fetchControlData = async controlId => {
		try {
			const urlControl = !this.props.match.path.startsWith('/my_controls/') ? PropertyBucket.getMyControlDetailByControlId(controlId) : PropertyBucket.getPostControlDetailByControlId(controlId);
			const data = await httpService.getService(urlControl, 'GET');

			await this.props.fetchPaymentClaimsData(data.project.metadata.projectId);

			mapNewAnswersToQuestion(data);

			this.setState(prevState => ({
				controlData: data,
				questionListData: data.questionList,
				blocksData: data.questionList.blocksInList,
				isWaiting: false,
				controlledParties: data.controlledParties,
				controlledPlaces: data.controlPlaces,
				controlledOrders: data.orders,
				controlledWops: data.paymentClaims,
				otherControlledProjects: data.otherControlledProjectNumbers || [],
				dateStart: data.dateStart === null ? '' : new Date(data.dateStart),
				dateEnd: data.dateEnd === null ? '' : new Date(data.dateEnd),
				controllingEntity: data.controllingEntity === null ? '' : data.controllingEntity,

				copiedSourceData: {
					...this.state.copiedSourceData,
					controllingEntity: data.controllingEntity === null ? '' : data.controllingEntity,
					dateStart: data.dateStart === null ? '' : new Date(data.dateStart),
					dateEnd: data.dateEnd === null ? '' : new Date(data.dateEnd),
					controlledParties: JSON.stringify(data.controlledParties),
					controlledPlaces: JSON.stringify(data.controlPlaces),
					controlledOrders: JSON.stringify(data.orders),
					controlledWops: JSON.stringify(data.paymentClaims),
					otherControlledProjects: JSON.stringify(data.otherControlledProjectNumbers || []),
				},

				controlListApproved: prevState.controlListApproved === null ? data.listValidated : prevState.controlListApproved
			}));
		} catch (error) {
			this.showPopup('Błąd', error.message, 'error');
		}
	};

	showPopup = (title, notification, type, onClickEvent, link, closePopUp = this.handleClosePopUpFunction) => {
		this.setState({
			showPopup: true,
			popUp: {
					title,
					notification,
					type,
				  	onClickEvent,
					link,
					closePopUp}
		})

	};

	cancelSave = () => {
		this.showPopup('Ostrzeżenie', PropertyBucket.getCancelMessage(), 'cancel', null, `/my_controls/active?number=${this.state.controlData.number}`)
	};

	onEditControlClick = () => {
		if (this.state.isLocked) {
			this.setState({isLocked: false, disabled: true})
			this.setState({isIntroductoryPartEdited: true})
		} else {
			this.showPopup('Ostrzeżenie', PropertyBucket.getCancelMessage(), 'cancel', () => {
				this.setState({isLocked: true});
				this.handleDisabledChange(false);
				this.setState({isIntroductoryPartEdited: false});
				this.setState({disabledSave: true});
			}, null)
		}
	};

	onPreparePostControlInfoClick = () => {
		this.showPopup('Przygotowanie informacji pokontrolnej', PropertyBucket.preparePostControlInfoMessage(), 'confirm', () => {
			this.preparePostControlInfo()
		})
	};

	onPreparePostControlNoteClick = () => {
		this.showPopup('Przygotowanie notatki pokontrolnej', PropertyBucket.preparePostControlNoteMessage(), 'confirm', () => {
			this.preparePostControlNote()
		})
	};

	hasAnswer = (item, index) => {
		return item.answers && (item.answers.answer !== '' && item.answers.answer !== null && item.answers.answer !== undefined )
	};

	validateControlDates = () => {
		if (this.state.dateStart) {
			return true
		}
		return false;
		// return controlData.dateStart <= controlData.dateEnd
	};

	validateControllingEntity = (controlData) => {
		return controlData.controllingEntity !== '' && controlData.controllingEntity !== null
	};

	validateControlParties = (controlData) => {
		return controlData.controlledParties && controlData.controlledParties.length > 0
	};

	validateControlPlaces = (controlData) => {
		return controlData.controlPlaces && controlData.controlPlaces.length > 0
	};

	validateList = (questionListData, _this) => {
		let __this = this;
		let blocksPassed = [];
		__this.blocksNotPassed = [];
		questionListData.blocksInList.forEach(function (block, index) {
			block.questionsInBlock.every(_this.hasAnswer) ? blocksPassed.push(block) : __this.blocksNotPassed.push({ blockNumber: index, block: block });
		});
		return blocksPassed.length === questionListData.blocksInList.length
	};

	getNotAllBlockFilledOutWithListErrorMessage = () => {
		let message = PropertyBucket.getNotAllBlockFilledOutErrorMessage() + ':';
		this.blocksNotPassed.forEach(({block, blockNumber}) => {
			message += `\n Blok ${blockNumber + 1}. ${block.name}`;

			block.questionsInBlock.forEach((question, index) => {
				if (!this.hasAnswer(question)) {
					message += `\n - pytanie nr ${index + 1}`;
				}
			});
		});

		return message;
	}

	preparePostControlInfo = () => {
		let _this = this;
		let questionListData = this.state.questionListData;
		let controlData = this.state.controlData;
		if (this.validateList(questionListData, _this) && this.validateControlDates() && this.validateControllingEntity(controlData) && this.validateControlParties(controlData) && this.validateControlPlaces(controlData)) {
			this.isWaitingOnOff(true);
			let postControlInfoDto = new PostControlInfoDto();
			let postControlDocumentDto = new PostControlDocumentDto();
			let controlDto = new ControlDto();
			controlDto.controlId = this.controlId;
			postControlDocumentDto.control = controlDto;
			postControlDocumentDto.postControlNote = null;
			postControlInfoDto.postControlDocument = postControlDocumentDto;
			postControlInfoDto.findings = this.generatePostControlInfoFindings(questionListData);
			postControlInfoDto.isFinalInfo = false;

			let url;
			let callPromise;

			let postControlDocument = new NewPostControlDocumentDto();
			postControlDocument.postControlInfo = postControlInfoDto


			url = PropertyBucket.getCreatePostControlDocument(this.controlId);
			callPromise = httpService.getServicePromise(url, 'PUT', postControlDocument, true);

			callPromise.then(
				function (message) {
					let infoId = message.postControlInfo.id;
					let controlId = controlData.id;
					_this.isWaitingOnOff(false);
					_this.showPopup('Komunikat', PropertyBucket.createPostControlInfoMessage(), 'confirm', () => {
						_this.redirectToInfo(infoId, controlId)
					}, null, () => {
						_this.props.history.push(`/my_controls/active?number=${controlData.number}`);
					});
					_this.setState({
						disabled: true
					})
				},
				function (error) {
					_this.isWaitingOnOff(false);
					if (error.status === 409) {
						_this.showPopup('Błąd', 'Informacja lub notatka pokontrolna już istnieje.', 'error');
						_this.setState({
							disabled: true
						})
					} else {
						_this.showPopup('Błąd', errorMessageText(error.status), 'error')
					}
				}
			)
		} else {
			let validationMessage = '';
			this.validateControlDates() === false ? validationMessage += PropertyBucket.getDateStartIsGreaterThanEndMessage() + '\n' : null;
			this.validateControllingEntity(controlData) === false ? validationMessage += PropertyBucket.getFillControllingEntityMessage() + '\n' : null;
			this.validateControlParties(controlData) === false ? validationMessage += PropertyBucket.getFillControlledPartiesMessage() + '\n' : null;
			this.validateControlPlaces(controlData) === false ? validationMessage += PropertyBucket.getFillControlPlacesMessage() + '\n' : null;
			this.validateList(questionListData, _this) === false ? validationMessage += _this.getNotAllBlockFilledOutWithListErrorMessage() : null;

			this.showPopup('Błąd', validationMessage, 'error')
		}

	};

	generatePostControlInfoFindings = (questionListData) => {
		let findings = [];
		questionListData.blocksInList.forEach(function (block, index) {
			block.questionsInBlock.forEach(function (question, i) {
				if (question.answers) {
					if (question.answers.relevantInPostControlNote) {
						let findingDto = new FindingDto();
						findingDto.title = question.questionContent;
						findingDto.content = question.answers.textAnswer;
						let blockInListDto = new BlockInListDto();
						blockInListDto.id = block.id;
						findingDto.blockInList = blockInListDto;
						findings.push(findingDto);
					}
				}
			})
		});

		return findings;
	};

	preparePostControlNote = () => {
		let _this = this;
		let questionListData = this.state.questionListData;
		let controlData = this.state.controlData;
		if (this.validateList(questionListData, _this) && this.validateControlDates() && this.validateControllingEntity(controlData) && this.validateControlParties(controlData) && this.validateControlPlaces(controlData)) {
			this.isWaitingOnOff(true);
			let postControlNoteDto = new PostControlNoteDto();
			postControlNoteDto.noteContent = this.generatePostControlNoteContent(questionListData);
			postControlNoteDto.attachments = [];

			let controlDto = new ControlDto();
			controlDto.controlId = this.controlId;

			let postControlDocumentDto = new PostControlDocumentDto();
			postControlDocumentDto.control = controlDto;
			postControlDocumentDto.postControlInfo = null;
			postControlDocumentDto.postControlNote = postControlNoteDto;

			let url;
			let callPromise;

			url = PropertyBucket.getCreatePostControlDocument(this.controlId);
			callPromise = httpService.getServicePromise(url, 'PUT', postControlDocumentDto, true);

			callPromise.then(
				function (message) {
					let noteId = message.postControlNote.id;
					let controlId = controlData.id;
					_this.isWaitingOnOff(false);
					_this.showPopup('Komunikat', PropertyBucket.createPostControlNoteMessage(), 'confirm', () => {
						_this.redirectToNote(noteId, controlId)
					}, null, () => {
						_this.props.history.push(`/my_controls/active/?number=${controlData.number}`);
					});
					_this.setState({
						disabled: true
					})
				},
				function (error) {
					_this.isWaitingOnOff(false);
					if (error.status === 409) {
						_this.showPopup('Błąd', 'Informacja lub notatka pokontrolna już istnieje.', 'error');
						_this.setState({
							disabled: true
						})
					} else {
						_this.showPopup('Błąd', errorMessageText(error.status), 'error')
					}
				}
			)
		} else {
			let validationMessage = '';
			this.validateControlDates() === false ? validationMessage += PropertyBucket.getDateStartIsGreaterThanEndMessage() + '\n' : null;
			this.validateControllingEntity(controlData) === false ? validationMessage += PropertyBucket.getFillControllingEntityMessage() + '\n' : null;
			this.validateControlParties(controlData) === false ? validationMessage += PropertyBucket.getFillControlledPartiesMessage() + '\n' : null;
			this.validateControlPlaces(controlData) === false ? validationMessage += PropertyBucket.getFillControlPlacesMessage() + '\n' : null;
			this.validateList(questionListData, _this) === false ? validationMessage += PropertyBucket.getNotAllBlockFilledOutErrorMessage() : null;

			this.showPopup('Błąd', validationMessage, 'error')
		}
	};

	generatePostControlNoteContent = (questionListData) => {
		let noteContent = '';
		questionListData.blocksInList.forEach(function (block, index) {
			block.questionsInBlock.forEach(function (question) {
				if (question.answers) {
					question.answers.relevantInPostControlNote ? noteContent += 'Uwaga do pytania: ' + question.questionContent + ': \n' + question.answers.textAnswer + '\n\n' : null;
				}
			})
		});
		noteContent === '' ? noteContent = emptyEditorContentPlainText : null;
		return noteContent;
	};

	redirectToInfo = (infoId, controlId) => {
		this.props.history.push('/my_controls/' + controlId + '/post_control_info/' + infoId);
	};

	redirectToNote = (noteId, controlId) => {
		this.props.history.push('/my_controls/' + controlId + '/post_control_note/' + noteId);
	};

	handleAlertBorder = (validated, className, newClasses, areAllFieldsPassed) => {
		if (validated) {
			let index = newClasses.indexOf('alertBorder');
			areAllFieldsPassed ? areAllFieldsPassed = true : null;
			if (index !== -1) {
				newClasses.splice(index, 1);
				this.setState({[className]: newClasses});
			}
		} else {
			areAllFieldsPassed = false;
			if (!newClasses.includes('alertBorder')) {
				newClasses.push('alertBorder');
			}
			this.setState({[className]: newClasses})
		}
		return areAllFieldsPassed;
	};

	handleAddParty = () => {
		const {
			controlledParties,
			tmpControlledPartyName,
			tmpControlledPartyIdType,
			tmpControlledPartyNip,
			tmpControlledPartyPesel,
			tmpControlledPartyForeignNumber,
		} = this.state;
		let copiedArray = controlledParties;

		let isNameNotEmpty = tmpControlledPartyName.length !== 0;
		let isIdTypeNotEmpty = tmpControlledPartyIdType !== '';
		let isIdValueNotEmpty = !(tmpControlledPartyNip === '' && (tmpControlledPartyPesel === null || tmpControlledPartyPesel === '') && tmpControlledPartyForeignNumber === '');
		let isNipValidated = (tmpControlledPartyIdType === 'nip' && tmpControlledPartyNip.length > 0) ? validator.validateNip(tmpControlledPartyNip) : true;
		let isPeselValidated = (tmpControlledPartyIdType === 'pesel' && tmpControlledPartyPesel !== null) ? validator.validatePesel(tmpControlledPartyPesel) : true;
		let isPeselUnique = (tmpControlledPartyIdType === 'pesel' && tmpControlledPartyPesel !== null) ? validator.listContainsValueClean(parseInt(tmpControlledPartyPesel, 10), controlledParties, 'pesel') : true;
		let isNipUnique = (tmpControlledPartyIdType === 'nip' && tmpControlledPartyNip.length > 0) ? validator.listContainsValueClean(tmpControlledPartyNip, controlledParties, 'nip') : true;
		let isForeignNumberUnique = (tmpControlledPartyIdType === 'foreignNumber' && tmpControlledPartyForeignNumber.length > 0) ? validator.listContainsValueClean(tmpControlledPartyForeignNumber, controlledParties, 'foreignNumber') : true;

		let allFieldsPassed = isNameNotEmpty && isIdTypeNotEmpty && isIdValueNotEmpty && isNipValidated && isPeselValidated && isPeselUnique && isNipUnique && isForeignNumberUnique;

		const setErrorIdValue = () => {
			if (!isIdValueNotEmpty) {
				return 'Pole nie może być puste'
			}
			if (!isNipValidated) {
				return 'NIP jest niepoprawny'
			}
			if (!isPeselValidated) {
				return 'PESEL jest niepoprawny'
			}
			if (!isPeselUnique) {
				return 'PESEL nie jest unikalny'
			}
			if (!isNipUnique) {
				return 'NIP nie jest unikalny'
			}
			if (!isForeignNumberUnique) {
				return 'Nr zagraniczny nie jest unikalny'
			}
			return '';
		};

		this.setState({
			errorControlledPartyName: isNameNotEmpty ? '' : 'Pole nie może być puste',
			errorControlledPartyIdType: isIdTypeNotEmpty ? '' : 'Wybierz typ identyfikatora',
			errorControlledPartiesIdValue: setErrorIdValue(),
		});

		if (allFieldsPassed) {
			let newItem = new ControlledPartyDto();
			newItem.name = tmpControlledPartyName;
			newItem.idType = tmpControlledPartyIdType;
			newItem.nip = tmpControlledPartyIdType === 'nip' ? tmpControlledPartyNip : '';
			newItem.pesel = tmpControlledPartyIdType === 'pesel' ? parseInt(tmpControlledPartyPesel, 10) : null;
			newItem.foreignNumber = tmpControlledPartyIdType === 'foreignNumber' ? tmpControlledPartyForeignNumber : '';
			copiedArray.push(newItem);
			this.setState({
				controlledParties: copiedArray,
				disabledSave: false,
				controlListApproved: false,
				addedToListInfo: tmpControlledPartyName,
				tmpControlledPartyName: '',
				tmpControlledPartyIdType: '',
				tmpControlledPartyNip: '',
				tmpControlledPartyPesel: null,
				tmpControlledPartyForeignNumber: '',
				controlledPartiesInputValueLength: 0,
				errorControlledPartyName: '',
				errorControlledPartyIdType: '',
				errorControlledPartiesIdValue: '',
			});

			setTimeout(() => {
				this.setState({addedToListInfo: null})
			}, 3000);
		}
	};

	handleAddPlace = (event) => {
		let copiedArray = this.state.controlledPlaces;
		let input = document.querySelector('#controlledPlacesInput').value;
		let isValidated = validator.getMustNotBeEmpty(input, 'controlledPlacesInputAlert');
		let isPlaceUnique = validator.listContainsValue(input, copiedArray, 'name', 'controlledPlacesInputAlert', 'Miejsce kontroli nie jest unikalne');
		let isFieldPassed = this.handleAlertBorder(isValidated && isPlaceUnique, 'placesClasses', this.state.placesClasses, true);

		if (isFieldPassed) {
			let newItem = new ControlPlaceDto();
			newItem.name = input;
			copiedArray.push(newItem);

			this.setState({
				controlledPlaces: copiedArray,
				disabledSave: false,
				controlListApproved: false,
				addedToListInfo: input,
				tmpControlledPlaces: '',
			});

			setTimeout(() => {
				this.setState({addedToListInfo: null})
			}, 3000);
		}
	};

	handleAddOrder = (event) => {
		const orderNumber = document.querySelector('#controlledOrderNumberInput').value;
		const orderName = document.querySelector('#controlledOrderNameInput').value;
		const orderContracts = document.querySelector('#controlledOrderContractInput').value;

		const copiedArray = this.state.controlledOrders;

		const isOrderNumberNotEmpty = validator.getMustNotBeEmpty(orderNumber, 'controlledOrderNumberAlert');

		const isOrderNameNotEmpty = validator.getMustNotBeEmpty(orderName, 'controlledOrderNameAlert');

		const isOrderNumberUnique = validator.listContainsValue(orderNumber, copiedArray, 'orderNumber', 'controlledOrderNumberAlert', 'Numer ogłoszenia o zamówieniu nie jest unikalny');

		let isOrderNumberValid = this.handleAlertBorder(isOrderNumberNotEmpty && isOrderNumberUnique, 'orderNumberClasses', this.state.orderNumberClasses, true);

		let isOrderNameValid = this.handleAlertBorder(isOrderNameNotEmpty, 'orderNameClasses', this.state.orderNameClasses, true);
		
		if(isOrderNumberValid && isOrderNameValid) {
			const newOrder = new OrderDto();
			newOrder.orderNumber = orderNumber;
			newOrder.orderName = orderName;
			newOrder.contracts = orderContracts;
			
			copiedArray.push(newOrder);
	
			this.setState({
				...this.state,
				controlledOrders: copiedArray,
				disabledSave: false,
				tmpControlledOrderNumber: '',
				tmpControlledOrderName: '',
				tmpControlledOrderContract: '',
				errorControlledOrderNumber: '',
				errorControlledOrderName: ''
			})
		}
	};

	handleAddPublicOrder = (order) => {
		const copiedArray = this.state.controlledOrders;

		const errorControlName = `errorControlledOrderNumber${order.announcementNumber}`;

		const isOrderNumberUnique = validator.listContainsValue(order.announcementNumber, copiedArray, 'orderNumber', errorControlName, 'Numer ogłoszenia o zamówieniu nie jest unikalny');

		let isOrderValid = this.handleAlertBorder(isOrderNumberUnique, `orderNumberClasses${order.announcementNumber}`, this.state[`orderNumberClasses${order.announcementNumber}`] ?? [], true);

		if(isOrderValid) {
			const newOrder = new OrderDto();
			newOrder.orderNumber = order.announcementNumber;
			newOrder.orderName = order.announcementName;
			newOrder.contracts = order.contracts;
	
			copiedArray.push(newOrder);
	
			this.setState({
				...this.state,
				controlledOrders: copiedArray,
				publicOrders: this.state.publicOrders.filter(x => x !== order),
				disabledSave: false,
				[errorControlName]: ''
			})
		} else {
			this.setState({...this.state, [errorControlName]: isOrderNumberUnique ? '' : 'Numer ogłoszenia o zamówieniu nie jest unikalny'});
		}
	}

	handleAddWop = (event) => {
		let copiedArray = this.state.controlledWops;
		let input = document.querySelector('#wopNumbers').value;
		let isValidated = validator.getMustNotBeEmpty(input, 'wopNumbersAlert');
		let isNumberStartsWithProject = validator.startsWithProjectNumber(input, 'wopNumbersAlert', 'Nieprawidłowy format numeru wniosku o płatność. Powinien zaczynać się od formatu: PROG.XX.YY-IN.ZZ-XXXX/RR');
		let isWopUnique = validator.listContainsValue(input, copiedArray, 'number', 'wopNumbersAlert', 'Numer wniosku nie jest unikalny');
		let isFieldPassed = this.handleAlertBorder(isValidated && isNumberStartsWithProject && isWopUnique, 'wopsClasses', this.state.wopsClasses, true);

		if (isFieldPassed) {
			let newItem = new PaymentClaimDto();
			newItem.number = input;
			copiedArray.push(newItem);

			this.setState({
				controlledWops: copiedArray,
				disabledSave: false,
				controlListApproved: false,
				addedToListInfo: input,
				tmpWopNumbers: '',
			});

			setTimeout(() => {
				this.setState({addedToListInfo: null})
			}, 3000);
		}
	};

	handleRemoveParty = (index) => {
		let parties = this.state.controlledParties;
		this.setState({removedFromListInfo: parties[index].name});
		parties.splice(index, 1);
		this.setState({
			controlledParties: parties,
			disabledSave: false,
			controlListApproved: false
		});

		setTimeout(() => {
			this.setState({removedFromListInfo: null})
		}, 3000);
	};

	handleRemovePlace = (index) => {
		let places = this.state.controlledPlaces;
		this.setState({removedFromListInfo: places[index].name});
		places.splice(index, 1);
		this.setState({
			controlledPlaces: places,
			disabledSave: false,
			controlListApproved: false
		});

		setTimeout(() => {
			this.setState({removedFromListInfo: null})
		}, 3000);
	};

	handleRemoveOrder = (index) => {
		let orders = this.state.controlledOrders;
		this.setState({removedFromListInfo: orders[index].order});
		orders.splice(index, 1);
		this.setState({
			controlledOrders: orders,
			disabledSave: false,
			controlListApproved: false
		});

		setTimeout(() => {
			this.setState({removedFromListInfo: null})
		}, 3000);
	};

	handleRemoveWop = (index) => {
		let wops = this.state.controlledWops;
		this.setState({removedFromListInfo: wops[index].number});
		wops.splice(index, 1);
		this.setState({
			controlledWops: wops,
			disabledSave: false,
			controlListApproved: false
		});

		setTimeout(() => {
			this.setState({removedFromListInfo: null})
		}, 3000);
	};

	handleAddOtherProject = (event) => {
		let copiedArray = this.state.otherControlledProjects;
		let input = document.querySelector('#otherProjectNumberInput').value;
		let isValidated = validator.getMustNotBeEmpty(input, 'otherProjectNumberInputAlert');
		let isFormatValid = validator.validateProjectNumber(input, 'otherProjectNumberInputAlert', 'Nieprawidłowy format numeru projektu. Wymagany format: PROG.XX.YY-IN.ZZ-XXXX/RR');
		let isProjectUnique = !copiedArray.includes(input);
		if (!isProjectUnique) {
			document.getElementById('otherProjectNumberInputAlert').innerHTML = '<span>Numer projektu nie jest unikalny</span>';
		}
		let isProjectNumber = input === this.state.controlData?.project?.metadata?.businessId;
		if (isProjectNumber) {
			document.getElementById('otherProjectNumberInputAlert').innerHTML = '<span>Nie można dodać numeru głównego projektu kontroli</span>';
		}
		let isFieldPassed = this.handleAlertBorder(isValidated && isFormatValid && isProjectUnique && !isProjectNumber, 'otherProjectNumberClasses', this.state.otherProjectNumberClasses, true);

		if (isFieldPassed) {
			copiedArray.push(input);

			this.setState({
				otherControlledProjects: copiedArray,
				disabledSave: false,
				controlListApproved: false,
				tmpOtherProjectNumber: '',
				addedToListInfo: input
			});

			setTimeout(() => {
				this.setState({addedToListInfo: null})
			}, 3000);
		}
	};

	handleRemoveOtherProject = (index) => {
		let projects = this.state.otherControlledProjects;
		this.setState({removedFromListInfo: projects[index]});
		projects.splice(index, 1);
		this.setState({
			otherControlledProjects: projects,
			disabledSave: false,
			controlListApproved: false
		});

		setTimeout(() => {
			this.setState({removedFromListInfo: null})
		}, 3000);
	};

	printPickedParties = () => (
		this.state.controlledParties.map((item, index) => (
			<p
				className='my-3'
				key={index}>
				<span
					className='added-item'
					key={index}
					array-key={index}
				>
					{formatSubject(item.idType, item.name, item.nip, item.pesel, item.foreignNumber)}
				</span>
				<button className='btn cancel-btn' onClick={() => this.handleRemoveParty(index)} disabled={this.state.isLocked}>
					USUŃ<span className='sr-only'> {formatSubject(item.idType, item.name, item.nip, item.pesel, item.foreignNumber)}</span>
				</button>
			</p>
		))
	);

	printPickedPlaces = (disabled) => {
		let _this = this;
		let placesCollection = this.state.controlledPlaces;
		let pickedPlaces = [];
		placesCollection.forEach(function (item, index) {
			let val = <p className='my-3' key={index}><span className='added-item' array-key={index}>{item.name}</span>
				<button className='btn cancel-btn' onClick={() => _this.handleRemovePlace(index)}
						disabled={disabled}>USUŃ<span className='sr-only'> {item.name}</span></button>
			</p>;
			pickedPlaces.push(val);
		});
		return pickedPlaces;
	};

	printPickedOtherProjects = (disabled) => {
		let _this = this;
		let projectsCollection = this.state.otherControlledProjects;
		let pickedProjects = [];
		projectsCollection.forEach(function (item, index) {
			let val = <p className='my-3' key={index}><span className='added-item' array-key={index}>{item}</span>
				<button className='btn cancel-btn' onClick={() => _this.handleRemoveOtherProject(index)}
						disabled={disabled}>USUŃ<span className='sr-only'> {item}</span></button>
			</p>;
			pickedProjects.push(val);
		});
		return pickedProjects;
	};

	printPickedOrders = (disabled) => {
		let _this = this;
		let ordersCollection = this.state.controlledOrders;
		let pickedOrders = [];
		ordersCollection.forEach(function (item, index) {

			const value = (
				<div className='row' style={{marginTop: 10}}>
					<div className='col'>{item.orderNumber}</div>
					<div className='col'>{item.orderName}</div>
					<div className='col'>{item.contracts}</div>
					<div style={{width: 150}}><button className='btn cancel-btn' onClick={() => _this.handleRemoveOrder(index)} disabled={disabled}>USUŃ<span className='sr-only'> {item.order}</span></button></div>
				</div>
			)
			pickedOrders.push(value);
		});
		return pickedOrders;
	};
	
	handleSelectAllPaymentClaims = () => {
		const paymentClaimsList = this.props.paymentClaims?.data || [];
		const allSelected = paymentClaimsList.every(paymentClaim => this.state.selectedPaymentClaims?.[paymentClaim.id]);
		this.setState({ selectedPaymentClaims: Object.fromEntries(paymentClaimsList.map(paymentClaim => [paymentClaim.id, !allSelected])) });
	}
	
	handlePaymentClaimCheckboxChange = (wopId) => {
		this.setState(prev => ({
			selectedPaymentClaims: {
				...prev.selectedPaymentClaims,
				[wopId]: !prev.selectedPaymentClaims[wopId],
			}
		}));
	}

	handleAddSelectedPaymentClaim = () => {
		const picked = this.props.paymentClaims?.data.filter(paymentClaim => this.state.selectedPaymentClaims[paymentClaim.id]);
		if (picked.length === 0) return;

		const existingPaymentClaims = new Set((this.state.controlledWops || []).map(paymentClaim => paymentClaim.number));
		const toAdd = picked
			.filter(paymentClaim => !existingPaymentClaims.has(paymentClaim.number))
			.map(paymentClaim => {
				const item = new PaymentClaimDto();
				item.number = paymentClaim.number;
				return item;
			});

		this.setState({
			controlledWops: toAdd.length > 0 ? [...(this.state.controlledWops || []), ...toAdd] : this.state.controlledWops,
			disabledSave: toAdd.length > 0 ? false : this.state.disabledSave,
			controlListApproved: toAdd.length > 0 ? false : this.state.controlListApproved,
			selectedPaymentClaims: {},
			addedToListInfo: toAdd.length > 0 ? toAdd.map(x => x.number).join(', ') : ''
		});

		setTimeout(() => this.setState({ addedToListInfo: null }), 3000);
	}

	printPickedWops = (disabled) => {
		let _this = this;
		let wopsCollection = this.state.controlledWops;
		let pickedWops = [];
		wopsCollection.sort((a, b) => a.number.localeCompare(b.number, undefined, { numeric: true })).forEach(function (item, index) {
			let val = <p className='my-3' key={index}><span className='added-item'
															array-key={index}>{item.number}</span>
				<button className='btn cancel-btn' onClick={() => _this.handleRemoveWop(index)} disabled={disabled}>USUŃ<span
					className='sr-only'> {item.number}</span></button>
			</p>;
			pickedWops.push(val);
		});
		return pickedWops;
	};

	listQuestions = (questions) => {
		let rows = [];
		if (questions) {
			questions.forEach(function (question, index) {
				let val = <p key={index} className='questionRow'>{question.question}</p>;
				rows.push(val);
			});
			return rows;
		} else {
			return 'Nie ma pytań';
		}
	};

	getControlData = (item) => {
		item.beneficiary = item.project.beneficiary;
		item.controlPlace = item.project.place;
		item.term = item.dateFrom + ' - ' + item.dateTo;
		item.kind = '';
		item.controlTeam = '';
		item.dictionaryEntries.forEach(function (value, index) {
			if (value.dictNumber === 1) {
				item.type = value.description;
			}
			if (value.dictNumber === 2) {
				item.mode = value.description;
			}
			if (value.dictNumber === 3) {
				item.kind += value.description + ', ';
			}
		});
		item.kind = item.kind.substr(0, (item.kind.length - 2));

		// prepare info about control team
		getControllingTeam(item);

		return item;
	};

	saveControl = (listValidated, savingListData = true) => {
		let controlData = this.state.controlData;
		this.isWaitingOnOff(true);
		const user = localStorage.getItem('user');
		let controlDto = new ControlDto();
		controlDto.controlId = controlData.id;
		controlDto.dateStart = customDateConversion(this.state.dateStart);
		controlDto.controllingEntity = this.state.controllingEntity;
		controlDto.controlledParties = this.state.controlledParties;
		controlDto.controlPlaces = this.state.controlledPlaces;
		controlDto.orders = this.state.controlledOrders;
		controlDto.paymentClaims = this.state.controlledWops;
		controlDto.otherControlledProjectNumbers = this.state.otherControlledProjects;
		controlDto.modificationPerson = user;
		controlDto.listValidated = listValidated;
		let url;
		let callPromise;

		url = PropertyBucket.getEditControlledInfo(controlData.id);
		callPromise = httpService.getServicePromise(url, 'PUT', controlDto);


		let _this = this;
		callPromise.then(
			function (message) {
				_this.isWaitingOnOff(false);
				if (savingListData) {
					_this.showPopup('Komunikat', PropertyBucket.saveControlListMessage(), 'notify')
				}
				_this.fetchControlData(_this.controlId);
				_this.setState({
					disabledSave: true,
					isLocked: true,
					disabled: false,
					isIntroductoryPartEdited: false
				});

				document.getElementById('wopNumbersAlert').innerHTML = '';
				_this.handleAlertBorder(true, 'wopsClasses', _this.state.wopsClasses, true)
				document.getElementById('controlledOrderNumberAlert').innerHTML = '';
				_this.handleAlertBorder(true, 'orderNumberClasses', _this.state.orderNumberClasses, true);
				document.getElementById('controlledOrderNameAlert').innerHTML = '';
				_this.handleAlertBorder(true, 'orderNameClasses', _this.state.orderNameClasses, true);
				document.getElementById('controlledPlacesInputAlert').innerHTML = '';
				_this.handleAlertBorder(true, 'placesClasses', _this.state.placesClasses, true);
				document.getElementById('otherProjectNumberInputAlert').innerHTML = '';
				_this.handleAlertBorder(true, 'otherProjectNumberClasses', _this.state.otherProjectNumberClasses, true);

				_this.setState({
					tmpControlledPartyName: '',
					tmpControlledPartyNip: '',
					tmpControlledPartyPesel: null,
					tmpControlledPartyForeignNumber: '',
					tmpControlledPartyIdType: '',
					controlledPartiesInputValueLength: 0,
					errorControlledPartyName: '',
					errorControlledPartyIdType: '',
					errorControlledPartiesIdValue: '',
					tmpWopNumbers: '',
					tmpControlledPlaces: '',
					tmpOrderNumbers: [],
					tmpOtherProjectNumber: '',
				})
			},
			function (error) {
				_this.isWaitingOnOff(false);
				_this.showPopup('Błąd', error, 'error')
			}
		)

	};

	printControlHeader() {
		const handleEditClick = () => {
			this.onEditControlClick();
			this.setState({activateFormInfo: true});
			this.setState({disabled: true});
		};

		let questionListData = this.state.questionListData;
		let controlData = this.state.controlData;
		this.state.isWaiting === false ? this.getControlData(controlData) : null;
		let disabled = isDisabled(this);
		let introductoryPartEdited = isIntroductoryPartEdited(this)
		let header;

		document.title = `e-Kontrole | Lista sprawdzająca dla kontroli: ${controlData?.number}`;

		const hasAnyAddablePaymentClaim = (this.props.paymentClaims?.data || []).some(pc => !this.state.controlledWops.some(({ number }) => number === pc.number));

		const hasAddableSelectedPaymentClaim = (this.props.paymentClaims?.data || []).some(pc => this.state.selectedPaymentClaims[pc.id] === true && !this.state.controlledWops.some(({ number }) => number === pc.number));

		if (questionListData && controlData && controlData.controlledParties) {
			header = <div id='listContainer'>
				<div>
					<button
						type='button'
						onClick={() => {
							generateControlListDocx(
								controlData,
								this.state.controlListApproved && controlData.listValidated,
							)
						}}
						className='doc-button'
					>
						<img
							className='ico-doc'
							src='/icoDoc.svg'
							alt='Pobierz dokument .docx'
						/>
					</button>
					{(!this.state.controlListApproved || !controlData.listValidated) && <span className='red h5'>WERSJA ROBOCZA</span>}
					<div className='btn_group my-1' style={{
						display: 'inline-block',
						float: 'right',
						width: '50%'
					}}>
						<button disabled={disabled || introductoryPartEdited} className='btn save-btn' onClick={() => this.checkControlList()}
						>
							SPRAWDŹ
							<span
								className='sr-only'> poprawność wypełnienia danych listy sprawdzającej dla kontroli nr {this.infoNumber}</span>
						</button>
					</div>
					<br/><br/>
					<h3 className='mb-5'>Lista sprawdzająca dla kontroli: {controlData.number}</h3>
					<ControlDetailInfo control={controlData} noControlledItems={true}/>
				</div>
				<h4 className='block_title-no-cursor mt-5' key={'controlEdit'}>Część wstępna kontroli</h4>
				<button className='btn save-btn my-3' id='controlEdit' onClick={handleEditClick}
				        disabled={disabled}>{this.state.isLocked ? 'EDYTUJ CZĘŚĆ WSTĘPNĄ' : 'ZAKOŃCZ EDYCJĘ'}</button>
				{this.state.activateFormInfo && <span className='sr-only' role='alert'>{this.state.isLocked ? 'Formularz części wstępnej jest nieaktywny' : 'Formularz części wstępnej jest aktywny'}</span>}
				<div className='controlListBlocks'>
					<DatePickerCustom
						labelClassName='input__label input__label--header'
						label='Data rozpoczęcia kontroli:'
						datePickerId='datePickerFrom'
						dateName='początkową'
						selected={this.state.dateStart}
						onChange={this.handleChangeStartDate}
						disabled={this.state.isLocked}
						autoComplete='off'
						parentRef={this.fromDateRef}
					/>
				</div>
				<Input
					chartsCount={this.state.controllingEntity.length || 0}
					chartCounterClassName='input__charts-counter--not-full'
					containerClassName='controlListBlocks'
					errorId='controllingEntityInputAlert'
					inputId='controllingEntityInput'
					className={this.state.controllingEntityClasses.join(' ') }
					label='Podmiot kontrolujący:'
					labelHeader
					maxLength={100}
					value={this.state.controllingEntity}
					onChange={this.handleChangeControllingEntity}
					disabled={this.state.isLocked}
				/>
				<div className='controlListBlocks'>
					<h5 className='mt-4 block-subtitle'>Podmioty kontrolowane:</h5>
					<div className='questionListInputs'>
						<div className='row'>
							<div className='col-md-6'>
								<Input
									chartsCount={this.state.tmpControlledPartyName.length || 0}
									errorId='controlledPartyNameAlert'
									error={this.state.errorControlledPartyName}
									invalid={this.state.errorControlledPartyName}
									inputId='controlledPartyNameInput'
									className={this.state.partyNameClasses.join(' ') }
									label='Nazwa podmiotu'
									maxLength={100}
									value={this.state.tmpControlledPartyName}
									onChange={this.handleChangeControlledPartyName}
									disabled={this.state.isLocked}
									errorClassName="relative-error"
								/>
							</div>
							<div className='col-md-3'>
								<SelectCustom
									values={this.state.tmpControlledPartyIdType || []}
									labelField='typeName'
									label='Typ identyfikatora'
									placeholder=''
									valueField='typeId'
									options={[
										{ typeId: 'nip', typeName: 'NIP' },
										{ typeId: 'pesel', typeName: 'PESEL' },
										{ typeId: 'foreignNumber', typeName: 'Nr zagraniczny' },
									]}
									id='selectTypeId'
									dropdownId='selectTypeDropdownId'
									onChange={this.handleChangeControlledPartyIdType}
									parentRef={this.selectTypeRef}
									disabled={this.state.isLocked}
									clearable={false}
									searchable={false}
									containerClassName='id-type-select'
									className={this.state.partyNameClasses.join(' ')}
									errorId='controlledPartyIdAlert'
									error={this.state.errorControlledPartyIdType}
									invalid={this.state.errorControlledPartyIdType}
									optionNameVisible={this.state.tmpControlledPartyIdType}
								/>
							</div>
							<div className='col-md-3'>
								<Input
									errorId='controlledPartyNipAlert'
									error={this.state.errorControlledPartiesIdValue}
									invalid={this.state.errorControlledPartiesIdValue}
									inputId='controlledPartyIdTypeInput'
									className={this.state.partyNameClasses.join(' ')}
									chartsCount={this.state.controlledPartiesInputValueLength}
									maxLength={!this.state.tmpControlledPartyIdType ? null : this.state.tmpControlledPartyIdType === 'nip' ? 10 : this.state.tmpControlledPartyIdType === 'pesel' ? 11 : 24}
									label='Identyfikator podmiotu'
									value={this.state.tmpControlledPartyNip || this.state.tmpControlledPartyPesel || this.state.tmpControlledPartyForeignNumber}
									onChange={this.handleChangeControlledPartyIdValue}
									disabled={this.state.isLocked || !this.state.tmpControlledPartyIdType}
									errorClassName="relative-error"
								/>
							</div>
						</div>
					</div>
					<button
						id='savePartiesBtn'
						className='btn save-btn add-btn'
						onChange={this.handleAddParty}
						onClick={this.handleAddParty}
						disabled={this.state.isLocked}
					>
						DODAJ<span className='sr-only'> podmiot kontrolowany</span>
					</button>
					{this.printPickedParties()}
				</div>
				<div className='controlListBlocks'>
					<div className='input-btn-container'>
						<Input
							chartsCount={this.state.tmpControlledPlaces.length || 0}
							errorId='controlledPlacesInputAlert'
							inputId='controlledPlacesInput'
							label='Miejsca przeprowadzenia kontroli:'
							labelHeader
							maxLength={150}
							value={this.state.tmpControlledPlaces}
							onChange={this.handleChangeControlledPlaces}
							disabled={this.state.isLocked}
						/>
						<button
							className='btn save-btn add-btn'
							onChange={this.handleAddPlace}
							onClick={this.handleAddPlace}
							disabled={this.state.isLocked}
						>
							DODAJ<span className='sr-only'> miejsce przeprowadzenia kontroli</span>
						</button>
					</div>
					{this.printPickedPlaces(this.state.isLocked)}
				</div>

				<div className='controlListBlocks'>
					<div className='input-btn-container'>
						<Input
							chartsCount={this.state.tmpOtherProjectNumber.length || 0}
							errorId='otherProjectNumberInputAlert'
							inputId='otherProjectNumberInput'
							label='Inne kontrolowane projekty:'
							labelHeader
							maxLength={50}
							value={this.state.tmpOtherProjectNumber}
							onChange={this.handleChangeOtherProjectNumber}
							disabled={this.state.isLocked}
						/>
						<button
							className='btn save-btn add-btn'
							onChange={this.handleAddOtherProject}
							onClick={this.handleAddOtherProject}
							disabled={this.state.isLocked}
						>
							DODAJ<span className='sr-only'> numer projektu</span>
						</button>
					</div>
					{this.printPickedOtherProjects(this.state.isLocked)}
				</div>

				<div className='controlListBlocks'>
					<h5 className='mt-4 block-subtitle'>Kontrolowane zamówienia:</h5>
					<button className='btn save-btn'
						disabled={this.state.isLocked}
						onChange={() => this.setState({...this.state, isControlledOrdersModalVisible: true})}
						onClick={() => {
							this.setState({...this.state, isControlledOrdersModalVisible: true})
							}}>
						WYBIERZ ZAMÓWIENIE
					</button>

						{this.state.publicOrders.map((order, index) => (
							<div className='row'>
								<div className='col'>
									<Input
										errorId={`errorControlledOrderNumber${order.announcementNumber}`}
										error={this.state[`errorControlledOrderNumber${order.announcementNumber}`]}
										invalid={this.state[`errorControlledOrderNumber${order.announcementNumber}`]}
										chartsCount={order.announcementNumber.length}
										inputId={`announcementNumber${order.announcementNumber}Input`}
										className={this.state[`orderNumberClasses${order.announcementNumber}`]?.join(' ') }
										label='Numer ogłoszenia o zamówieniu'
										maxLength={255}
										value={order.announcementNumber}
										disabled={true}
										errorClassName="relative-error"
									/>
								</div>

								<div className='col'>
									<Input
											inputId={`announcementName${order.announcementNumber}Input`}
											chartsCount={order.announcementName.length}
											maxLength={1000}
											label='Nazwa zamówienia'
											value={order.announcementName}
											disabled={true}
										/>
								</div>

								<div className='col'>
									<Input
										inputId={`announcementContract${order.announcementNumber}Input`}
										chartsCount={order.contracts?.length ?? 0}
										maxLength={255}
										label='Kontrakty'
										value={order.contracts}
										onChange={(event) => {
											order.contracts = event.target.value;
											this.forceUpdate();
										}}
										disabled={this.state.isLocked}
									/>
								</div>

								<div style={{display: 'grid', width: 150}}>
									<button
										className='btn save-btn add-btn'
										style={{float: 'right', margin: 'auto 0px', display: 'block'}}
										onClick={() => this.handleAddPublicOrder(order)}
										disabled={this.state.isLocked}
									>
										DODAJ<span className='sr-only'> zamówienie</span>
									</button>
								</div>

							</div>
						))}
				
						<div className='row'>
							<div className='col'>
								<Input
									chartsCount={this.state.tmpControlledOrderNumber.length || 0}
									errorId='controlledOrderNumberAlert'
									error={this.state.errorControlledOrderNumber}
									invalid={this.state.errorControlledOrderNumber}
									inputId='controlledOrderNumberInput'
									label='Numer ogłoszenia o zamówieniu'
									className={this.state.orderNumberClasses.join(' ') }
									maxLength={255}
									value={this.state.tmpControlledOrderNumber}
									onChange={this.handleChangeControlledOrderNumber}
									disabled={this.state.isLocked}
									errorClassName="relative-error"
								/>
							</div>
							<div className='col'>
							<Input
									errorId='controlledOrderNameAlert'
									error={this.state.errorControlledOrderName}
									invalid={this.state.errorControlledOrderName}
									inputId='controlledOrderNameInput'
									className={this.state.orderNameClasses.join(' ') }
									chartsCount={this.state.tmpControlledOrderName.length || 0}
									maxLength={1000}
									label='Nazwa zamówienia'
									value={this.state.tmpControlledOrderName}
									onChange={this.handleChangeControlledOrderName}
									disabled={this.state.isLocked}
									errorClassName="relative-error"
								/>
							</div>
							<div className='col'>
								<Input
									errorId='controlledOrderContractAlert'
									error={this.state.errorControlledOrderContract}
									invalid={this.state.errorControlledOrderContract}
									inputId='controlledOrderContractInput'
									chartsCount={this.state.tmpControlledOrderContract.length || 0}
									maxLength={255}
									label='Kontrakty'
									value={this.state.tmpControlledOrderContract}
									onChange={this.handleChangeControlledOrderContract}
									disabled={this.state.isLocked}
									errorClassName="relative-error"
								/>
							</div>
							<div style={{display: 'grid', width: 150}}>
								<button
									className='btn save-btn add-btn'
									style={{float: 'right', margin: 'auto 0px', display: 'block'}}
									onClick={this.handleAddOrder}
									disabled={this.state.isLocked}
								>
									DODAJ<span className='sr-only'> zamówienie</span>
								</button>
							</div>
						</div>
					{this.state.isControlledOrdersModalVisible &&
						<PopUp
							active={false}
							type="custom"
							customContent
							title='Kontrolowane zamówienia'
							handleClosePopup={() => {
								this.setState({...this.state, isControlledOrdersModalVisible: false});
							}}>
								<PublicOrdersProvider 
									projectId={this.state.controlData.project.metadata.projectId}
									pickedOrders={[...this.state.controlledOrders.map(x => ({'announcementName': x.orderName, 'announcementNumber': x.orderNumber})), ...this.state.publicOrders]}
									onPick={orders => this.onPublicOrdersPickHandle(orders)}
									onClose={this.onPublicOrdersCloseHandle} />
							</PopUp>
						}
					{this.state.controlledOrders?.length > 0 && 
						<div className='row'>
							<div className='col'><b>Numer ogłoszenia o zamówieniu</b></div>
							<div className='col'><b>Nazwa zamówienia</b></div>
							<div className='col'><b>Kontrakty</b></div>
							<div style={{width: 150}}/>
						</div>}

					{this.printPickedOrders(this.state.isLocked)}
				</div>

				<div className='controlListBlocks'>
					<h5 className='mt-4 block-subtitle'>Numery kontrolowanych WoP:</h5>
					<div>
						<div style={{ maxHeight: 500, overflowY: 'auto'}} >
							<div style={{ display: 'flex', width: '100%', border: '1px solid #e0e0e0' }}>
								<label htmlFor="paymentClaimsSelectAll" className="input-label payment-claim" style={{ cursor: this.state.isLocked ? 'default' : 'pointer' }}>
									Zaznacz wszystkie
								</label>
								<div style={{ flex: '1', display: 'flex', alignItems: 'center' }}>
									<Checkbox
										checked={this.props.paymentClaims?.data.filter(pc => !this.state.controlledWops.some(w => w.number === pc.number)).every(pc => this.state.selectedPaymentClaims[pc.id])}
										disabled={this.state.isLocked || !hasAnyAddablePaymentClaim}
										inputProps={{ id: 'paymentClaimsSelectAll' }}
										onChange={this.handleSelectAllPaymentClaims}
									/>
								</div>
							</div>
							{this.props.paymentClaims?.data.length === 0 && <div className='payment-claim' style={{ display: 'flex', width: '100%', border: '1px solid #e0e0e0', borderTop: 'none' }}> Brak wniosków do wyboru z listy. </div>}
							{(this.props.paymentClaims?.data || []).map(paymentClaim => (
								<div key={paymentClaim.id} style={{ display: 'flex', width: '100%', border: '1px solid #e0e0e0', borderTop: 'none' }}>
									<label	htmlFor={`paymentClaim-${paymentClaim.id}`} className='payment-claim' style={{ cursor: this.state.isLocked ? 'default' : 'pointer' }}>
										{ paymentClaim.number }
									</label>
									<div style={{ flex: '1', display: 'flex', alignItems: 'center' }}>
										<Checkbox
											checked={!!this.state.selectedPaymentClaims[paymentClaim.id] || this.state.controlledWops.some(({ number }) => number === paymentClaim.number)}
											disabled={this.state.isLocked || this.state.controlledWops.some(({ number }) => number === paymentClaim.number)}
											inputProps={{ id: `paymentClaim-${paymentClaim.id}` }}
											onChange={() => this.handlePaymentClaimCheckboxChange(paymentClaim.id)}
										/>
									</div>
								</div>
							))}
						</div>
						<button
							disabled={this.state.isLocked || !hasAddableSelectedPaymentClaim}
							className='btn save-btn'
							style={{ marginTop: 20 }}
							onClick={this.handleAddSelectedPaymentClaim}
						>
							DODAJ ZAZNACZONE WoP
						</button>
					</div>

					<hr style={{ marginBottom: 1 }} />
					<div className='input-btn-container'>
						<Input
							errorId='wopNumbersAlert'
							inputId='wopNumbers'
							label='Wprowadź numer WoP ręcznie:'
							maxLength={255}
							chartsCount={this.state.tmpWopNumbers.length || 0}
							value={this.state.tmpWopNumbers}
							onChange={this.handleChangeWopNumbers}
							disabled={this.state.isLocked}
						/>
						<button
							className='btn save-btn save-btn--low add-btn'
							onClick={this.handleAddWop}
							disabled={this.state.isLocked || !this.state.tmpWopNumbers.length}
						>
							DODAJ<span className='sr-only'> numer kontrolowanego WoP</span>
						</button>
					</div>
					{this.printPickedWops(this.state.isLocked)}
				</div>
				<div id='buttonsSection' className='controlListBlocks'>
					<button
						className='btn save-btn'
						disabled={this.state.disabledSave}
						onClick={() => this.saveControl(false)}
					>
						ZAPISZ<span className='sr-only'> część wstępną kontroli</span>
					</button>
				</div>
				{this.state.addedToListInfo && <span className='sr-only' role='alert'>Dodano {this.state.addedToListInfo}</span>}
				{this.state.removedFromListInfo && <span className='sr-only' role='alert'>Usunięto {this.state.removedFromListInfo}</span>}
			</div>
		}
		return header;
	}

	onPublicOrdersPickHandle = (orders) => {
		this.setState({...this.state, isControlledOrdersModalVisible: false, publicOrders: orders});
	}

	onPublicOrdersCloseHandle = () => this.setState({...this.state, isControlledOrdersModalVisible: false});

	printBlockSection() {
		let questionList = this.state.questionListData;
		let section = [];
		section.push(<AnswerTable key={'control-' + this.controlId} controlId={this.controlId}
		                          controlUuid={this.state.controlData.uuid} questionList={questionList}
		                          disabled={false} isLocked={this.state.isLocked} history={this.props.history}
		                          projectUuid={this.state.controlData.project.metadata.uuid}
		                          onDisabledChange={this.handleDisabledChange}
								  answerBlockStatus={this.state.controlData.answerBlockStatus}
								onSaveBlockData={this.handleSaveBlockData}/>);
		return section;
	}

	handleSaveBlockData = () => {
		//zbędny dwukrotny zapis bloku z pytaniami - do weryfikacji czy nie będzie problemu dalej
		// this.saveControl(false, false)
		this.setState({controlListApproved: false})
	}

	handleDisabledChange = (disabled) => {
		this.setState({disabled: disabled});
		if(disabled === false) {
			this.setState({
				tmpControlledPartyName: '',
				tmpControlledPartyIdType: '',
				tmpControlledPartyNip: '',
				tmpControlledPartyPesel: null,
				tmpControlledPartyForeignNumber: '',
				tmpControlledPlaces: '',
				tmpOrderNumbers: '',
				tmpWopNumbers: '',
				tmpOtherProjectNumber: '',
			});
			this.fetchControlData(this.controlId)

			document.getElementById('wopNumbersAlert').innerHTML = '';
			this.handleAlertBorder(true, 'wopsClasses', this.state.wopsClasses, true)

			const foundControlledOrderNumberAlert = document.getElementById('controlledOrderNumberAlert');

			if(foundControlledOrderNumberAlert) {
				document.getElementById('controlledOrderNumberAlert').innerHTML = '';
			}

			this.handleAlertBorder(true, 'orderNumberClasses', this.state.orderNumberClasses, true);

			const foundControlledOrderNameAlert = document.getElementById('controlledOrderNameAlert');

			if(foundControlledOrderNameAlert) {
				document.getElementById('controlledOrderNameAlert').innerHTML = '';
			}

			this.handleAlertBorder(true, 'orderNameClasses', this.state.orderNameClasses, true);
			document.getElementById('controlledPlacesInputAlert').innerHTML = '';
			this.handleAlertBorder(true, 'placesClasses', this.state.placesClasses, true);

			this.setState({
				errorControlledPartyName: '',
				errorControlledPartyIdType: '',
				errorControlledPartiesIdValue: '',
			});
		}
	};

	goBack = () => {
		this.props.history.goBack();
	};

	render() {
		//let blocksData = this.state.blocksData;
		let list = this.state.questionListData;
		let popUp;
		this.state.showPopup ?
			(popUp = <PopUp type={this.state.popUp.type}
							title={this.state.popUp.title}
							notification={this.state.popUp.notification}
							link={this.state.popUp.link ? this.state.popUp.link : null}
							onClickEvent={this.state.popUp.onClickEvent}
							closePopUp={this.state.popUp.closePopUp}
			/>) : null;
		let disabled = isDisabled(this);
		let introductoryPartEdited = isIntroductoryPartEdited(this);
		
		return (
			<div>
				{this.state.isPreventPromptEnabled && !this.state.isLocked && <Prompt when={!this.state.isChangeRoutePossible} message={this.preventChangeRoute}/>}
				{popUp}
				<div>
					{this.printControlHeader()}

					{list ? (<h4 id='blocks_section_title'>Bloki z pytaniami: </h4>,
						this.printBlockSection(list)) : null}
				</div>
				{this.state.isWaiting === false ?
					(<div className='mt-4'>
						<button className={this.state.postContInfoClasses.join(' ')} disabled={this.state.disabled || this.state.introductoryPartEdited || !this.state.controlListApproved || !this.state.controlData.listValidated}
						        onClick={this.onPreparePostControlInfoClick}>SPORZĄDŹ INFORMACJĘ POKONTROLNĄ
						</button>
						<button className={this.state.postContNoteClasses.join(' ')} disabled={this.state.disabled || this.state.introductoryPartEdited || !this.state.controlListApproved || !this.state.controlData.listValidated}
								onClick={this.onPreparePostControlNoteClick}>SPORZĄDŹ NOTATKĘ POKONTROLNĄ
						</button>
						<button disabled={disabled || introductoryPartEdited} className='btn save-btn margin-left-20px' onClick={() => this.checkControlList()}>
							SPRAWDŹ
							<span
								className='sr-only'> poprawność wypełnienia danych listy sprawdzającej dla kontroli nr {this.infoNumber}</span>
						</button>
						<button className='btn cancel-btn' onClick={this.cancelSave}>ANULUJ</button>
						<br/><br/>
					</div>) : <button className='btn save-btn' id='plus_img_container' onClick={this.goBack}><i data-v-db6946bc=''
																												aria-hidden='true'
																												className='v-icon material-icons theme--light v-list-text'>arrow_back</i><span>WRÓĆ</span>
					</button>}
				<div id='waiter'><Waiter loading={this.state.isWaiting}/></div>

				<div className='controlListBlocks' style={{marginTop: 0}}>
					<h4 className='mt-4'>Dane audytowe: </h4>
					{<AuditDetail 
						auditData={{
							createdOn: this.state.controlData?.listCreatedOn,
							createdByLogin: this.state.controlData?.listCreatedByLogin,
							createdBy: this.state.controlData?.listCreatedBy,
							updatedOn: this.state.controlData?.listUpdatedOn,
							updatedByLogin: this.state.controlData?.listUpdatedByLogin,
							updatedBy: this.state.controlData?.listUpdatedBy,
						}}>
					</AuditDetail>}
				</div>
			</div>
		);
	}
}

function isDisabled(obj) {
	return obj.state.disabled === true && obj.state.isLocked === true;
}

function isIntroductoryPartEdited(obj) {
	return obj.state.isIntroductoryPartEdited === true
}

const mapStateToProps = (state) => {
	return { 
		...state,
		paymentClaims: {
			...state.paymentClaims,
			data: (state.paymentClaims?.data || [])
				.map(pc => ({
					...pc,
					number: pc.number.replace(/-\d+$/, '')
				}))
				.sort((a, b) => a.number.localeCompare(b.number, undefined, { numeric: true }))
		},
	};
};

const mapDispatchToProps = (dispatch) => {
  return {
	fetchPaymentClaimsData: (projectId) =>
	  dispatch(
		getPaymentClaimsData(projectId)
	  )
  };
};

export const ControlListProvider = connect(
	mapStateToProps,
	mapDispatchToProps
)(ControlList);
